import { XWeatherConditions, XWeatherSunMoon } from '../../lib/xweather';
import firstQuarterImg from './moon_phases/first_quarter.png';
import fullMoonImg from './moon_phases/full_moon.png';
import lastQuarterImg from './moon_phases/last_quarter.png';
import newMoonImg from './moon_phases/new_moon.png';
import waningCrescentImg from './moon_phases/waning_crescent.png';
import waningGibbousImg from './moon_phases/waning_gibbous.png';
import waxingCrescentImg from './moon_phases/waxing_crescent.png';
import waxingGibbousImg from './moon_phases/waxing_gibbous.png';

export type PressureTrend = 'rising' | 'falling' | 'steady';

export const moonPhaseImages = {
  'first quarter': firstQuarterImg,
  'full moon': fullMoonImg,
  'last quarter': lastQuarterImg,
  'new moon': newMoonImg,
  'waning crescent': waningCrescentImg,
  'waning gibbous': waningGibbousImg,
  'waxing crescent': waxingCrescentImg,
  'waxing gibbous': waxingGibbousImg,
} as const;

export const pressureGroup = (pressure: number) => {
  if (pressure < 29.7) {
    return 'Low';
  } else if (pressure >= 29.7 && pressure <= 30.4) {
    return 'Medium';
  }

  return 'High';
};

export const mockWeatherConditions: XWeatherConditions = {
  icon: 'sunny.png',
  spressureIN: 0,
  tempF: 0,
  windDir: 'N',
  windDirDEG: 0,
  windSpeedMPH: 0,
  sky: 0,
  weatherPrimary: 'weather',
  pop: 0,
  profile: {
    tz: 'America/Chicago',
  },
};

export const mockSolunarData: XWeatherSunMoon = {
  sun: {
    riseISO: '2024-06-25T06:00:00-05:00',
    setISO: '2024-06-25T10:00:00-05:00',
  },
  moon: {
    riseISO: '2024-06-25T06:00:00-05:00',
    setISO: '2024-06-25T10:00:00-05:00',
    transitISO: '2024-06-25T12:00:00-05:00',
    underfootISO: '2024-06-25T18:00:00-05:00',
    phase: {
      phase: 100,
      illum: 100,
      name: 'full moon',
    },
  },
  profile: {
    tz: 'America/Chicago',
  },
};
